import dynamicViews from './dynamic-views';
import schoolPicker from './school-picker';
import LinkWrappers from '../link-wrappers';
import CookiebotHelper from '../cookiebot-helper';

const materialsView = (() => {


  const self = {
    dom: {
      view: null
    },
    linkWrappers: null,
    dynamicView: null,
    titleSeparator: ' - ', //separator between schoolname and rest of the title
    cookiebotHelper: null
  };

  function init() {
    self.dynamicView = dynamicViews.getView('walk-materials');
    self.cookiebotHelper = new CookiebotHelper();

    if(!self.dynamicView) {
      return;
    }

    self.dom.view = document.querySelector('.js-dynamic-view__content');

    const params = self.dynamicView.params ? JSON.parse(self.dynamicView.params) : {};

    // We want to generate missing files on every request, if school is missing materials
    schoolPicker.setExtraRequestParams('school', {
      generateMissingFiles: 1
    });

    schoolPicker.on('loading', (schoolId) => {
      self.dynamicView.replaceUrl(); // Use view base url
      self.dynamicView.showLoader();
    });

    schoolPicker.on('complete', (schoolId, data) => {
      if(data) {
        self.dynamicView.replaceUrl(schoolId);
        self.dynamicView.render(data);
        if(data?.school?.name) {
          self.dynamicView.replaceTitle(data.school.name, self.titleSeparator);
        }

        // update linkWrappers eventlisteners - clickable materials
        self.linkWrappers = new LinkWrappers(self.dom.view.querySelectorAll('.js-link-wrapper'));
        self.linkWrappers.update(self.dom.view.querySelectorAll('.js-link-wrapper'))

        // ReInit Cookiebot for youtube iFrame videos
        if (window.Cookiebot) {
          window.Cookiebot.init()
          self.cookiebotHelper.initCustomWidgetOpeners('[data-open-cookiebot]');
        }
      }
    });

    // If initial server rendered school doesn't have all registered materials, trigger generation
    if(params.schoolId && params.materials && params.materials.missingFiles) {
      schoolPicker.loadSchool(params.schoolId);
    }
  }

  return {
    init
  }
})();

export default materialsView;
export { materialsView };
